import { useEffect } from "react";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { Platform } from "react-native";

const useFavicon = () => {
  const { faviconUrl, orgName } = useOrgSettingsSlice();

  const updateFavicon = async () => {
    try {
      const link: HTMLLinkElement | null =
        document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = faviconUrl;
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = faviconUrl;
        document.head.appendChild(newLink);
      }
    } catch (error) {
      console.error("Error updating favicon:", error);
    }
  };

  const updateOrganizationName = () => {
    if (orgName) {
      document.title = orgName;
    }
  };

  useEffect(() => {
    if (Platform.OS === "web") {
      if (faviconUrl) {
        updateFavicon();
      }
      updateOrganizationName();
    }
  }, [faviconUrl, orgName]);
};

export default useFavicon;
